<template>
<div class="owlOverlay" ref="test" v-if="images.length > 0">
<carousel class="main_carousel_container" 
  :autoplay="true" 
  :loop="true" 
  :center="true" 
  :items="1" 
  :dotsContainer="'.dotsContainer'" 
  :nav="true"
  :autoplayTimeout="6000"
  @changed="changed"
  :navContainer="'.navContainer'"
>
      <div class="slider_item_wrapper" v-for="img in images" :key="img.id" :style="`background-image: ${img.style}, url(${img.url})`">
      <div class="first"><h1 class="slider_heading">{{img.heading_text}}</h1></div>
      <div v-if="!img.fb" class="second"><button v-scroll-to='img.button_href' class="slider_button">{{img.button_text}}</button></div>
      <div v-else class="second"><a class="slider_button fb" v-bind:href='img.button_href'>Facebook</a></div>
      </div>
</carousel>
<div class="dotsContainer"></div>
<div class="navContainer" v-if="$mq =='small'">
  <div class="nav-bottom" v-if="$mq ==='small'" @click="prevPage" :class="{phone: this.page === 0, prev: this.page > 0}">
    <a href="tel:600830436" :class="{rgh: this.page === 0}" v-if="page === 0">Zadzwoń do nas</a>
    <p v-else-if="page === 1">Oferta</p>
    <p v-else>Kontakt</p>
  </div>
  <div class="nav-bottom nav-bottom2" @click="nextPage" v-if="$mq==='small'">
    <p v-if="page === 0 ">Oferta</p>
    <p v-else-if="page === 1">Kontakt</p>
    <p v-else>Strona główna</p>
  </div>
</div>
</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import carousel from 'vue-owl-carousel';
export default {
    name: 'Slider',
    components: { carousel },
    data(){
      return{
        page: 0,
      }
    },
    computed:{
    ...mapState({
        images: state => state.carousel.carouselImages,
    })
  },
  methods:{
    ...mapMutations(['bindImages']),
    changed(data){
      this.page = data.page.index;
    },
    nextPage(){
      document.querySelector('.owl-next').click();
    },
    prevPage(){
      if(this.page !== 0){
        document.querySelector('.owl-prev').click();
      }
    }
  },
  mounted(){
    // this if prevents multiple bind images
    if(this.images.length === 0){
      this.bindImages();
    }
  }
}
</script>

<style lang="scss">
.rgh{
  padding-left: 52px;
  color: white;
  text-decoration: none;
}
.nav-bottom{
  width: 50%;
  color: white;
}
.fb{
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
}
.owlOverlay{
  position: relative;
}
@media (max-width: 360px){
  .owlOverlay{
      max-height: 650px;
  }
}
.main_carousel_container{
    width: 100%;
    height: 100vh;
}
.slider_item_wrapper{
    width: 100%;
    height: 600px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-size: cover !important;
    background-position: center !important;
}
.slider_heading{
  margin: 0 33px 0 34px;
  font-size: 61px;
  font-weight: bold;
  line-height: 81.7%;
  text-shadow: 0px 4px 12px rgba(0, 0, 0, 0.25);
  color: white;
}
.slider_button{
  background: none;
  border: 2px solid white;
  width: 160px;
  height: 40px;
  color: white;
  text-transform: uppercase;
}
.first{
  display: flex;
  justify-content: center;
  align-items: flex-end;
  width: 100%;
  height: 60%;
}
.second{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 40%;
}
.dotsContainer{
  width: 100%;
  position: absolute;
  // display: none;
  bottom: 70px;
  left: 0;
  z-index: 10;
  display: flex;
  justify-content: center;
  button{
    width: 12px;
    height: 12px;
    border: none;
    margin: 6px;
    border-radius: 20px;
    &:focus{
      outline: none;
    }
  }
  .active{
    background: white;
  }
}
.navContainer{
  width: 100%;
  height: 52px;
  display: flex;
  justify-content: space-around;
  flex-direction: row;
  position: absolute;
  bottom: 0;
  left: 0;
  background: #333333;
  z-index: 10;
  div{
    width: 50%;
    height: 52px;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #333333;
  }
}
.owl-prev, .owl-next{
  display: none !important;
}
.phone::before{
  content: '';
  background: url('../assets/phone.png') no-repeat;
  background-size: 80%;
  position: absolute;
  left: 10px;
  bottom: -5px;
  margin: auto;
  top: 0;
  width: 25px;
  height: 25px;
}
.prev::before{
  content: '';
  background: url('../assets/next.png') no-repeat;
  background-size: 65%;
  background-position: center;
  position: absolute;
  left: 15px;
  bottom: 0;
  margin: auto;
  top: 0;
  width: 25px;
  height: 25px;
  transform: rotate(180deg);
}
.nav-bottom2::after{
  content: '';
  background: url('../assets/next.png') no-repeat;
  background-size: 65%;
  background-position: center;
  position: absolute;
  right: 15px;
  bottom: 0;
  margin: auto;
  top: 0;
  width: 25px;
  height: 25px;
}
@media (max-width: 359px){
  .slider_heading{
    font-size: 52px;
    line-height: 48px;
  }
  .nav-bottom{
    font-size: 12px;
  }
}
@media (min-width: 600px){
  .main_carousel_container{
    width: 100%;
    height: 460px;
  }
  .slider_item_wrapper{
    height: 460px;
  }
  .dotsContainer{
    display: none;
  }
  .slider_heading{
    font-size: 50px;
  }
  .slider_button{
    width: 120px;
    height: 36px;
    font-size: 13px;
  }
}
@media (min-width: 900px){
  .first{
    justify-content: flex-start;
  }
  .second{
    justify-content: flex-start;
    align-items: flex-start;
  }
  .slider_button{
    margin: 34px;
  }
  .slider_heading{
    width: 500px;
  }
  .dotsContainer{
    bottom: 40%;
    left: 95%;
    width: auto;
    flex-direction: column;
  }
}
@media (min-width:1440px){
  .owlOverlay{
    padding: 130px 100px 0 100px;
    width: 100%;
  }
   .dotsContainer{
    display: flex;
  }
  .main_carousel_container{
    width: 100%;
    height: 660px;
  }
  .slider_item_wrapper{
    height: 660px;
  }
  .first{
    justify-content: flex-start;
    .slider_heading{
      margin: 0 72px;
      font-size: 72px;
      font-weight: lighter;
    }
  }
  .second{
    justify-content: flex-start;
    align-items: flex-start;
    .slider_button{
          margin: 24px 72px;
    }
  }
  .navContainer{
    bottom: 0;
    left: calc(100% - 200px);
    width: 100px;
    .owl-prev, .owl-next{
      width: 50%;
      color: transparent;
      font-size: 0;
      cursor: pointer;
    }
  }
  .dotsContainer{
    bottom: calc(50% - 106px);
    left: calc(100% - 140px);
    width: auto;
    flex-direction: column;
    button{
      cursor: pointer;
      background: none;
      border: 2px solid white;
    }
  }
  .owl-prev::before{
    background: url('../assets/next.png') no-repeat;
    background-size: 20px;
    background-position: center;
    transform: rotate(180deg);
}
.slider_button{
  cursor: pointer;
}
}
</style>